module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av339-581142408db2bddfc02e2d3a264b5bf3.jpg";